module.exports = __webpack_public_path__ + "img/magento-setup-tuning.5a6c4568.jpg";